import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { hasOpenDialogs } from '../../../../core/functions/dialog-helper';
import { ModalComponent } from '../../../../shared/components/modal/modal.component';
import { WELCOME_BANNER_MESSAGES } from './constants/welcome-banner-constants';
import { WelcomeBannerService } from './services/welcome-banner.service';
import { UserStateService } from '../../../user/shared/services/user-state/user-state.service';

@Component({
    selector: 'app-welcome-banner',
    templateUrl: './welcome-banner.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatCardModule, MatIconModule],
})
export class WelcomeBannerComponent implements OnInit {
    visible = false;

    constructor(
        private dialog: MatDialog,
        private welcomeBannerService: WelcomeBannerService,
        private userStateService: UserStateService,
    ) {}

    ngOnInit(): void {
        const userId = this.userStateService.getUser()?.id;
        if (userId) {
            this.welcomeBannerService
                .getWelcomeBannerStatus(userId)
                .subscribe((status) => {
                    this.visible = status;
                });
        }
    }

    hideWelcomeBanner(): void {
        if (hasOpenDialogs(this.dialog)) {
            return;
        }

        this.dialog.open(ModalComponent, {
            disableClose: true,
            data: {
                title: WELCOME_BANNER_MESSAGES.HIDE_CONFIRMATION_TITLE,
                content: WELCOME_BANNER_MESSAGES.HIDE_CONFIRMATION_CONTENT,
                primaryAction: {
                    title: 'OK',
                    action: () => {
                        this.dialog.closeAll();
                        this.visible = false;
                        const userId = this.userStateService.getUser()?.id;
                        if (userId) {
                            this.welcomeBannerService
                                .hideWelcomeBanner(userId)
                                .subscribe();
                        }
                    },
                },
                isShowCancel: true,
            },
        });
    }
}
